import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ctaHref } from '../variants';

export function Reveal({ children, delay = 0, className = '' }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Section({ children, className = '', id }) {
  return (
    <section id={id} className={`relative px-4 py-20 md:py-28 ${className}`}>
      <div className="relative mx-auto max-w-3xl">{children}</div>
    </section>
  );
}

export function Eyebrow({ children }) {
  return (
    <p className="mb-5 text-xs font-bold uppercase tracking-[0.25em] text-[#F5A623]">
      {children}
    </p>
  );
}

// Two-line heading in Dan's style: heavy uppercase, second line in the gold
// gradient (depthme/depthme HeroSection).
export function Heading({ lines, as: Tag = 'h2', className = '' }) {
  const [first, second] = lines;
  return (
    <Tag className={`font-jakarta font-black uppercase leading-none tracking-tight text-white ${className}`}>
      {first}
      {second && (
        <span className="mt-2 block text-gradient-gold">{second}</span>
      )}
    </Tag>
  );
}

export function Cta({ variant, children, className = '' }) {
  return (
    <a
      href={ctaHref(variant.key)}
      target="_blank"
      rel="noopener noreferrer"
      className={`btn-gold pulse-glow group inline-flex min-h-[56px] items-center justify-center gap-2 rounded-xl px-8 py-5 text-lg ${className}`}
    >
      {children || variant.ctaLabel}
      <span aria-hidden className="transition-transform duration-300 group-hover:translate-x-1">→</span>
    </a>
  );
}
